import { React, useContext } from "react";

import "react-toastify/dist/ReactToastify.css";

import reportAPI from "apis/panel/reports/reports";

import Context from "context/context";

import Grid from "@mui/material/Grid";

import Button from "@mui/material/Button";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  width: "100vw",
  borderRadius: "10px",
  maxHeight: "90vh",
  overflowY: "scroll",
};

const VraRadPoolReport = ({ setDisableDropdown }) => {
  const { dispatch } = useContext(Context);

  const { getVraRadPoolingReportAPI } = reportAPI();

  
  const handleExport = async () => {
   
    dispatch({ type: "SET_LOADING", payload: true });
    setDisableDropdown(true);

    await getVraRadPoolingReportAPI();
    setDisableDropdown(false);
    dispatch({ type: "SET_LOADING", payload: false });
  };

  return (
    <div>
      <Grid container spacing={4} sx={{ mt: 2 }}>
      
     
      </Grid>

      <Grid container>
        <Grid item xs={12} style={{ textAlign: "right", padding: "20px 0px" }}>
          

          <Button
            className="download-btn"
            startIcon={
              <DownloadForOfflineIcon
                style={{ fontSize: 30, verticalAlign: "middle" }}
              />
            }
            onClick={handleExport}
          >
            Export
          </Button>
        </Grid>
      </Grid>

      
    </div>
  );
};

export default VraRadPoolReport;
